export default __webpack_public_path__ + "static/media/189.88be8640.gif";